/* istanbul ignore file */
/* It's not possible to fill VGS fields in Cypress */

import { Request, Response, checkCardApi } from '@api/reservation/checkCard'
import { makeMutation } from '@lib/mutation'

export const useCheckCard = makeMutation<Request, Response>({
  key: 'checkCard',
  loader: async body => await checkCardApi(body),
})
